export default __webpack_public_path__ + "static/media/cern-medium-italic.7b3a13b3.ttf";